export const STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD = 'StripeCard';
export const STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH = 'StripeAchBankAccount';

export const STRIPE_PAYMENT_INSTRUMENT_API_TYPES = {
  card: STRIPE_PAYMENT_INSTRUMENT_TYPE_CARD,
  'stripe-ach-bank-account': STRIPE_PAYMENT_INSTRUMENT_TYPE_ACH,
};

export function stripePaymentInstrumentApiType(instrument) {
  return STRIPE_PAYMENT_INSTRUMENT_API_TYPES[instrument?.constructor.modelName] ?? null;
}
